import angular from 'angular'
import modalDetailsCtrl from './modalDetailsCtrl.js'
import modalSumCtrl from './modalSumCtrl.js'
import modalUnindentificationCtrl from './modalUnindentificationCtrl.js'
import { identificationSummarize } from 'redevConfig'
const list = (identificationSummarize && identificationSummarize.list) || ''

const identificationSummarizeList = list ? require(`redevelopment/statistics/identificationSummarize/${list.templateName}`) : require('./views/identificationSummarize.html')
const identificationSummarizeListCtrl = list ? require(`redevelopment/statistics/identificationSummarize/${list.controllerName}`) : require('./identificationSummarizeCtrl.js')

export default angular
    .module('statistics.inputStatistics.identificationSummarize', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('statistics.inputStatistics.identificationSummarize', {
            abstract: true,
            url: '/identificationSummarize',
            abstract: true,
            template: '<div ui-view></div>',
            title: '认证汇总',
            default: 'statistics.inputStatistics.identificationSummarize.list',
        })
        $stateProvider.state('statistics.inputStatistics.identificationSummarize.list', {
            url: '/list',
            template: identificationSummarizeList,
            controller: 'identificationSummarizeListCtrl',
        })
    }])
    .controller('identificationSummarizeListCtrl', identificationSummarizeListCtrl.default)
    .controller('modalDetailsCtrl', modalDetailsCtrl)
    .controller('modalSumCtrl', modalSumCtrl)
    .controller('modalUnindentificationCtrl', modalUnindentificationCtrl)
    .filter('periodNameDate', () => function (data) {
        if (!data) return data
        return `${data[0] + data[1] + data[2] + data[3]}年${data[4]}${data[5]}月`
    })
    .name



// WEBPACK FOOTER //
// ./src/app/statistics/inputStatistics/identificationSummarize/index.js